// Import here your languages
import en from './locales/en.json';

// Set here you favourite default language
export const defaultLanguage = 'en';

// Export here your language files import
export const languagesResources = {
    en: { translation: en },
};

export const availableLanguages = ['en'];
